import { render, staticRenderFns } from "./LiveAppInstall.vue?vue&type=template&id=7f2779fc&"
import script from "./LiveAppInstall.vue?vue&type=script&lang=ts&"
export * from "./LiveAppInstall.vue?vue&type=script&lang=ts&"
import style0 from "./LiveAppInstall.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports